import { AfterViewInit, Component, OnDestroy, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { ViewerConstants } from "../../shared/model/viewer-constants";
import { PhoenixViewerService } from "../../viewer-components/services/internal-services/viewer-services/phoenix-viewer.service";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  selector: "ground-elevation-popup",
  templateUrl: "./ground-elevation-popup.component.html",
  styleUrls: ["./ground-elevation-popup.component.scss"],
  standalone: false,
})
export class GroundElevationPopupComponent implements AfterViewInit, OnDestroy {
  viewerService = inject(VIEWER_SERVICE);

  subscriptions: Subscription[] = [];

  data: any;

  conversion: string;

  ngAfterViewInit() {
    this.subscriptions.push(
      this.viewerService.measurementSystemId$.subscribe((currentSystemId) => {
        this.conversion = this.viewerService.getMeasurementConversion(
          "LENGTH_MIDDLE",
          ViewerConstants.MEASUREMENT_SYSTEMS.IDS.METRIC,
          currentSystemId,
        );
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }
}
